import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { ClipboardIcon, CheckIcon } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/base";
export const CopyButton = ({ content, showCopied = "button", icon = _jsx(ClipboardIcon, { className: "h-4 w-4" }), ...props }) => {
    const [isCopied, setIsCopied] = useState(false);
    const onCopy = async () => {
        if (!navigator.clipboard || !window.isSecureContext) {
            console.error("Clipboard not available.");
            return;
        }
        try {
            await navigator.clipboard.writeText(content);
            if (showCopied === "toast") {
                toast.success("Copied to clipboard");
            }
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 3000);
        }
        catch (err) {
            console.error("Failed to copy.", err);
        }
    };
    return (_jsx(Button, { size: "icon", variant: "outline", onClick: onCopy, className: "border-0", style: { backgroundColor: "transparent" }, ...props, children: isCopied ? _jsx(CheckIcon, { className: "h-4 w-4 text-green-500" }) : icon }));
};
//# sourceMappingURL=CopyButton.js.map